/**
 * pendantMapApi.js — API functions for the PalPendant Locator Map page.
 *
 * fetchPendantLocations(campusId) — Fetches all pendant device locations + alerted devices
 * pingPendantDevice(deviceId, meta) — Sends a location ping command to a specific device
 */

import { apiFetch, apiRemoteCommand } from '../../../../services/api.js';

// ---------------------------------------------------------------------------
// Fetch pendant locations
// ---------------------------------------------------------------------------
/**
 * Fetches all pendant locations and alerted devices for a campus.
 *
 * @param {number} campusId
 * @returns {Promise<Array>} — [{ locations: [...], alerted: [...] }]
 */
export async function fetchPendantLocations(campusId) {
    return apiFetch({
        procedure: 'getallpendantlocations',
        reqType: 'stored',
        payload: { campus_id: campusId },
    });
}

// ---------------------------------------------------------------------------
// Ping pendant device
// ---------------------------------------------------------------------------
/**
 * Sends a remote "location" command to a pendant device.
 *
 * @param {string} deviceId — manufacture_uuid of the device
 * @param {{ campusId: number, userId: string, clientId: string }} meta
 * @returns {Promise<boolean>} — true if command accepted
 */
export async function pingPendantDevice(deviceId, meta) {
    return apiRemoteCommand({
        campusId: meta.campusId,
        userId: meta.userId,
        clientId: meta.clientId,
        payload: { devid: deviceId, command: 'location' },
    });
}
